import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
export class SIMAAPIs extends EarthBrainViewerAPIs {
    async loadSIMAFile(simaFile, options) {
        return await this._scDesign.loadSIMAFile(simaFile, options);
    }
    hasSIMACentralLine(id) {
        return this._scDesign.hasSIMACentralLine(id);
    }
    setSIMAVisibility(id, visible) {
        this._scDesign.setSIMAVisibility(id, visible);
    }
    zoomToSIMA(id) {
        this._scDesign.zoomToSIMA(id);
    }
    removeSIMA(id) {
        this._scDesign.removeSIMA(id);
    }
    exportCenterlineToSima(alignmentId, siteName, filename = "output") {
        this._scDesign.exportAlignmentToSima(alignmentId, siteName, filename);
    }
    exportAlignmentToSima(alignmentId, siteName, filename = "output") {
        this._scDesign.exportAlignmentToSima(alignmentId, siteName, filename);
    }
    exportLineWorksToSima(lineWorksId, siteName, filename = "output") {
        this._scDesign.exportLineWorksToSima(lineWorksId, siteName, filename);
    }
    exportArbitraryLineToSima(lineWorksId, siteName, filename = "output") {
        this._scDesign.exportArbitraryLineToSima(lineWorksId, siteName, filename);
    }
    exportSIMAToSima(simaId, siteName, filename = "output") {
        this._scDesign.exportSIMAToSima(simaId, siteName, filename);
    }
    /**
     * Alias for exportSIMAToSima with consistent (simaId, siteName, filename) parameter order.
     */
    exportSIMAToFile(simaId, siteName, filename = "output") {
        this._scDesign.exportSIMAToSima(simaId, siteName, filename);
    }
    getCentralLineDataOfSIMA(id) {
        return this._scDesign.getCentralLineDataOfSIMA(id);
    }
    getSIMALineJSON(id) {
        return this._scDesign.getSIMALineJSON(id);
    }
}
//# sourceMappingURL=sima-apis.js.map